export const getToken = () => {
  return {
    type: "GET_TOKEN"
  };
};

export const setToken = token => {
  return {
    type: "SET_TOKEN",
    token
  };
};

export const unauthenticateToken = () => {
  return {
    type: "UNAUTHENTICATE_TOKEN"
  };
};



// WEBPACK FOOTER //
// ./src/actions/token.actions.js